import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";

export const MyReviews = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/reviews/my/reviews").then((r) => setData(r.data)).catch(() => setData({ finalized: [], in_progress: [] }));
  }, []);

  if (!data) return <Skeleton className="h-80 w-full rounded-none" />;

  return (
    <div className="space-y-4 max-w-4xl" data-testid="my-reviews">
      {data.in_progress.length > 0 && (
        <div className="bg-white border border-border px-4 py-3 flex items-center gap-3" data-testid="my-reviews-inprogress">
          <p className="text-[12px] text-muted-foreground">In progress:</p>
          {data.in_progress.map((r, i) => (
            <span key={i} className="text-[10px] font-mono border border-slate-300 text-slate-600 px-2 py-0.5 uppercase">
              {r.cycle_name} — {r.status.replace("_", " ")}
            </span>
          ))}
          <p className="text-[11px] text-muted-foreground ml-auto">Reviews become visible once finalized by your manager.</p>
        </div>
      )}

      {data.finalized.length === 0 && (
        <div className="bg-white border border-border px-4 py-10 text-center text-[13px] text-muted-foreground">
          No finalized reviews yet.
        </div>
      )}

      {data.finalized.map((r) => (
        <div key={r.id} className="bg-white border border-border" data-testid={`my-review-${r.id}`}>
          <div className="px-5 py-4 border-b border-border flex items-center justify-between">
            <div>
              <p className="text-[14px] font-semibold text-[var(--brand-primary)]">{r.cycle_name}</p>
              <p className="text-[11px] font-mono text-muted-foreground mt-0.5">
                finalized {String(r.finalized_at).slice(0, 10)} by {r.finalized_by}
              </p>
            </div>
            <div className="text-right">
              <p className="text-[9px] font-semibold uppercase tracking-wider text-muted-foreground">Final rating</p>
              <p className="text-2xl font-bold font-mono text-teal-700">{r.final?.rating}<span className="text-[13px] text-slate-400 font-normal"> / 5</span></p>
            </div>
          </div>
          <div className="px-5 py-4 space-y-4">
            <p className="text-[13px] text-slate-700 leading-relaxed">{r.final?.performance_summary}</p>
            <div className="grid grid-cols-2 gap-5">
              <div>
                <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-teal-700 mb-1.5">Strengths</p>
                <ul className="space-y-1.5">
                  {(r.final?.strengths || []).map((s, i) => (
                    <li key={i} className="text-[12.5px] text-slate-700 pl-3 border-l-2 border-teal-600">{s}</li>
                  ))}
                </ul>
              </div>
              <div>
                <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-amber-700 mb-1.5">Growth areas</p>
                <ul className="space-y-1.5">
                  {(r.final?.growth_areas || []).map((s, i) => (
                    <li key={i} className="text-[12.5px] text-slate-700 pl-3 border-l-2 border-amber-500">{s}</li>
                  ))}
                </ul>
              </div>
            </div>
            {(r.final?.development_actions || []).length > 0 && (
              <div>
                <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-teal-700 mb-1.5">Development actions</p>
                <div className="border border-border divide-y divide-border">
                  {r.final.development_actions.map((a, i) => (
                    <div key={i} className="px-3 py-2 flex items-center justify-between gap-3">
                      <p className="text-[12.5px] text-slate-700">{a.action}</p>
                      {a.course && (
                        <span className="text-[10px] font-mono bg-teal-50 border border-teal-600/30 text-teal-800 px-1.5 py-0.5 shrink-0">
                          {a.course}
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MyReviews;
